import { Button, Group, Loader, Text } from '@mantine/core';
import type { ReactNode } from 'react';

import classes from './QuickPromptChips.module.css';

/**
 * A quick prompt suggestion for contextual actions.
 */
export interface QuickPrompt {
  id: string;
  label: string;
  prompt: string;
  icon?: ReactNode;
}

export interface QuickPromptChipsProps {
  prompts: QuickPrompt[];
  onPromptClick: (prompt: QuickPrompt) => void;
  loading?: boolean;
}

/**
 * Renders quick prompt suggestions as clickable chips.
 * Used in expanded row panels to suggest contextual actions.
 */
export function QuickPromptChips({ prompts, onPromptClick, loading }: QuickPromptChipsProps) {
  if (loading) {
    return (
      <Group className={classes.container} gap="xs">
        <Loader size="xs" />
        <Text c="dimmed" size="sm">
          Loading suggestions...
        </Text>
      </Group>
    );
  }

  if (prompts.length === 0) {
    return null;
  }

  return (
    <Group className={classes.container} gap="xs" wrap="wrap">
      {prompts.map((prompt) => (
        <Button
          className={classes.chip}
          key={prompt.id}
          leftSection={prompt.icon}
          onClick={() => onPromptClick(prompt)}
          size="xs"
          variant="light"
        >
          {prompt.label}
        </Button>
      ))}
    </Group>
  );
}
